import {VerifyExport} from './VerifyExport';
import {SoftwareAcknowledgements} from './SoftwareAcknowledgements';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { AccountJourney } from './AccountJourney';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/manrope/latin-500.css';
import '@fontsource/manrope/latin-600.css';
import '@fontsource/manrope/latin-700.css';
import './styles.css';
import { DesktopAccount } from './DesktopAccount';
import { installDesktopAccountTransport } from './desktopAccountBridge';
import './workbench-account.css';
import './workbench.css';
import './portal-design.css';
import { installAccountPasteAudit } from './accountPasteAudit';
const desktopAccount = location.pathname === '/desktop/account';
if (desktopAccount) installDesktopAccountTransport();
if (desktopAccount) installAccountPasteAudit();
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>{location.pathname==='/licenses'?<SoftwareAcknowledgements/>:location.pathname==='/verify-export'?<VerifyExport/>:desktopAccount ? <DesktopAccount /> : <AccountJourney />}</React.StrictMode>,
);
